export const billing = {
    title: "প্ল্যান ও বিলিং",
    description: "আপনার প্ল্যান, এতে কী কী আছে, এবং এর পেমেন্ট।",
    current: {
        title: "বর্তমান প্ল্যান",
        trial: "{{date}} পর্যন্ত ফ্রি ট্রায়াল",
        paidUntil: "{{date}} পর্যন্ত পরিশোধিত ({{cycle}})",
        noSubscription: "এখনো পেমেন্ট হয়নি",
        pending: "{{date}} থেকে {{plan}} প্ল্যান",
        keep: "বর্তমান প্ল্যানই থাকুক",
    },
    cycles: { monthly: "মাসিক", yearly: "বার্ষিক" },
    perCycle: { monthly: "{{price}} / মাস", yearly: "{{price}} / বছর" },
    addons: {
        title: "অ্যাড-অন",
        names: { locations: "বাড়তি লোকেশন", devices: "বাড়তি POS ডিভাইস", sms: "SMS প্যাক" },
        amount: {
            locations_one: "{{n}}টি বাড়তি লোকেশন",
            locations_other: "{{n}}টি বাড়তি লোকেশন",
            devices_one: "{{n}}টি বাড়তি POS ডিভাইস",
            devices_other: "{{n}}টি বাড়তি POS ডিভাইস",
            sms_one: "{{n}}টি SMS ক্রেডিট",
            sms_other: "{{n}}টি SMS ক্রেডিট",
        },
        perMonth: "{{what}} — মাসে {{price}}",
        perPack: "{{what}} — {{price}}",
        buy: "কিনুন",
        packs: "কতটি",
        until: "{{date}} পর্যন্ত",
        noEnd: "মেয়াদ শেষ হয় না",
        needsPlan: "অ্যাড-অন পেতে প্ল্যান কেনা থাকতে হবে। আগে প্ল্যানের পেমেন্ট করুন।",
    },
    plans: {
        title: "আপনার দোকানের প্রতিটি ধাপের প্ল্যান",
        choose: "বেছে নিন",
        popular: "সবচেয়ে জনপ্রিয়",
        currentBadge: "বর্তমান",
        subtitle: "সব প্ল্যানে POS, এক স্টক আর ফ্রি আপডেট আছে। ব্যবসা বাড়লে যেকোনো সময় প্ল্যান বদলান।",
        saveUpTo: "{{percent}}% পর্যন্ত সাশ্রয়",
        savePercent: "{{percent}}% সাশ্রয়",
        none: "এই মুহূর্তে কোনো প্ল্যান নেই।",
        notOnCycle: "এই মেয়াদে বিক্রি হয় না",
        per: { monthly: "/ মাস", yearly: "/ বছর" },
        billedYearly: "মাসে {{price}}, বছরে একবার বিল",
        cta: {
            start: "এই প্ল্যানের পেমেন্ট করুন",
            renew: "নবায়ন করুন",
            upgrade: "আপগ্রেড করুন",
            switch: "এই প্ল্যানে যান",
        },
        everythingIn: "{{plan}}-এর সব কিছু, সাথে:",
        includes: "যা আছে:",
        compare: "সব ফিচার মিলিয়ে দেখুন",
        hideCompare: "তুলনা লুকান",
        feature: "ফিচার",
        included: "আছে",
        notIncluded: "নেই",
        groups: {
            usage: "লিমিট",
            channels: "বিক্রির উপায়",
            stock: "স্টক ও অপারেশন",
            delivery: "ডেলিভারি",
            payments: "পেমেন্ট",
            customers: "কাস্টমার",
            accounts_reports: "হিসাব ও রিপোর্ট",
            team: "টিম",
            integrations: "ইন্টিগ্রেশন",
            support: "সাপোর্ট",
        },
        unlimited: "সীমাহীন",
        limits: {
            "locations.max": "{{limit}}টি লোকেশন",
            "users.max": "{{limit}} জন স্টাফ",
            "devices.max": "{{limit}}টি POS ডিভাইস",
            "products.max": "{{limit}}টি পণ্য",
            "orders.monthly.max": "মাসে {{limit}}টি অর্ডার",
            "storefront.landing_pages.max": "{{limit}}টি ল্যান্ডিং পেজ",
        },
    },
    quote: {
        title: "{{plan}}, {{cycle}}",
        kinds: {
            new: "আপনার প্রথম পরিশোধিত সময়কাল",
            renewal: "পরের সময়কালের নবায়ন",
            upgrade: "এখনই আপগ্রেড: এই সময়কালের বাকি অংশের টাকা লাগবে",
            downgrade: "পেমেন্ট লাগবে না: এই সময়কাল শেষে ছোট প্ল্যান শুরু হবে",
        },
        subtotal: "মূল্য",
        discount: "ছাড়",
        vat: "ভ্যাট",
        total: "পরিশোধ করতে হবে",
        period: "সময়কাল",
        coupon: "কুপন কোড",
        applyCoupon: "প্রয়োগ",
        scheduleDowngrade: "সময়কাল শেষে পরিবর্তন",
        back: "প্ল্যানে ফিরে যান",
    },
    pay: {
        method: "কীভাবে পেমেন্ট করবেন?",
        bkash: "বিকাশ",
        cash: "নগদ টাকা",
        bkashSteps: "বিকাশ অ্যাপ খুলুন → {{number}} ({{type}}) নম্বরে Send Money → পরিমাণ {{amount}}। তারপর নিচে আপনার বিকাশ নম্বর ও TrxID দিন।",
        accountTypes: { personal: "পার্সোনাল", agent: "এজেন্ট", merchant: "মার্চেন্ট" },
        senderPhone: "আপনার বিকাশ নম্বর",
        trxId: "ট্রানজেকশন আইডি (TrxID)",
        cashHelp: "Sobthik-কে নগদে পরিশোধ করুন। পেমেন্ট নিশ্চিত হলেই প্ল্যান চালু হবে।",
        note: "নোট (ঐচ্ছিক)",
        submit: "অনুমোদনের জন্য পাঠান",
        copy: "কপি",
        copied: "কপি হয়েছে",
    },
    open: {
        waitingTitle: "পেমেন্ট অনুমোদনের অপেক্ষায়",
        waiting: "আপনার {{amount}} পেমেন্ট যাচাই করা হচ্ছে। অনুমোদন হলেই প্ল্যান চালু হবে।",
        withdraw: "ফিরিয়ে নিন",
        rejectedTitle: "পেমেন্ট অনুমোদন হয়নি",
        rejected: "কারণ: {{reason}}। যাচাই করে আবার পাঠান।",
        openTitle: "ইনভয়েস {{number}} এখনো পরিশোধ হয়নি",
    },
    invoices: {
        title: "ইনভয়েস",
        empty: "এখনো কোনো ইনভয়েস নেই।",
        number: "নম্বর",
        issued: "তারিখ",
        total: "মোট",
        status: "অবস্থা",
        pdf: "PDF",
        statuses: {
            open: "অপরিশোধিত",
            awaiting_approval: "অনুমোদনের অপেক্ষায়",
            paid: "পরিশোধিত",
            overdue: "মেয়াদোত্তীর্ণ",
            credited: "বাতিল",
        },
    },
    account: {
        grace: "আপনার পেমেন্ট বকেয়া। {{date}} পর্যন্ত সব চালু থাকবে; দ্রুত পরিশোধ করুন।",
        restricted: "পেমেন্ট বকেয়া: নতুন পণ্য, স্টাফ ও লোকেশন যোগ বন্ধ। POS ও অর্ডার চলছে। {{date}} তারিখে অ্যাকাউন্ট স্থগিত হবে।",
        suspendedTitle: "আপনার অ্যাকাউন্ট স্থগিত",
        suspendedBody: "আপনার POS-এ বিক্রি ও সিঙ্ক চলছে। আবার সব ব্যবহার করতে প্ল্যানের পেমেন্ট করুন — সঙ্গে সঙ্গে চালু হবে।",
        payNow: "এখনই পেমেন্ট করুন",
    },
    submitted: "পাঠানো হয়েছে। অনুমোদন হলেই জানানো হবে।",
    downgradeScheduled: "এই সময়কাল শেষে আপনার প্ল্যান পরিবর্তন হবে।",
    licence: {
        title: "লাইসেন্স",
        description: "এটি একটি ডেডিকেটেড Sobthik ইনস্ট্যান্স। এর সীমা আপনার লাইসেন্স থেকে আসে।",
        customer: "লাইসেন্সধারী",
        expires: "মেয়াদ",
        issued: "ইস্যু",
        id: "লাইসেন্স আইডি",
        limits: "সীমা ও ফিচার",
        unlimited: "সীমাহীন",
        included: "আছে",
        notIncluded: "নেই",
        valid: "বৈধ",
        invalid: "বৈধ নয়",
        invalidBody: "লাইসেন্স যাচাই করা যায়নি: {{problem}}। আপনার Sobthik অ্যাকাউন্ট ম্যানেজারের সাথে যোগাযোগ করুন; POS বিক্রি চালিয়ে যাবে।",
        expiresSoon: "লাইসেন্স {{date}} তারিখে শেষ হবে। নবায়নের জন্য আপনার Sobthik অ্যাকাউন্ট ম্যানেজারের সাথে যোগাযোগ করুন।",
        expired: "লাইসেন্স {{date}} তারিখে শেষ হয়েছে। ধাপে ধাপে কিছু কাজ সীমিত হবে; POS বিক্রি চালিয়ে যাবে।",
        features: {
            "feature.pos": "POS",
            "feature.multi_location": "একাধিক লোকেশন",
            "feature.custom_roles": "নিজস্ব রোল",
            "feature.api": "API অ্যাক্সেস",
            "feature.storefront": "অনলাইন স্টোর",
            "feature.custom_domain": "নিজস্ব শপ ডোমেইন",
        },
        extraLimits: {
            "sms.credits": "{{limit}}টি SMS ক্রেডিট",
        },
    },
};
//# sourceMappingURL=billing.js.map